import React from "react";
import { useQuery } from "@apollo/client";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Alert from "@mui/material/Alert";
import { useUserProfile } from "@app.automotus.io/components/hooks";
import { GET_PERMIT_TYPES_FOR_PAYEE, GetPermitTypesForPayeeData, GetPermitTypesForPayeeVars } from "common/graphql";
import { PendingApplicationsDataGrid, PermitsEmptyState } from "./components";

export const PendingApplications: React.FC = () => {
  const { userProfile } = useUserProfile();
  const payeeAccountId = userProfile?.account?.id;

  // Fetch permit types for filter options
  const { data: permitTypesData, loading: permitTypesLoading } = useQuery<
    GetPermitTypesForPayeeData,
    GetPermitTypesForPayeeVars
  >(GET_PERMIT_TYPES_FOR_PAYEE, {
    variables: { payeeAccountId: payeeAccountId || "" },
    skip: !payeeAccountId,
  });

  const permitTypeOptions = React.useMemo(() => {
    return (
      permitTypesData?.permitTypes.map((pt) => ({
        value: pt.name,
        label: pt.name,
      })) || []
    );
  }, [permitTypesData?.permitTypes]);

  if (!payeeAccountId) {
    return (
      <Alert severity="error" sx={{ m: 2 }}>
        Unable to load applications. Please try again later.
      </Alert>
    );
  }

  const hasNoPermitProgram = !permitTypesLoading && permitTypesData?.permitTypes.length === 0;

  return (
    <Stack sx={{ height: "100%", flexGrow: 1 }} spacing={3}>
      {/* Header */}
      <Typography variant="h5" component="h1" fontWeight={600}>
        Pending Applications
      </Typography>

      {hasNoPermitProgram ? (
        <PermitsEmptyState />
      ) : !permitTypesLoading ? (
        <PendingApplicationsDataGrid permitTypeOptions={permitTypeOptions} />
      ) : null}
    </Stack>
  );
};

export default PendingApplications;
